import { render, staticRenderFns } from "./ServiceAccounts.vue?vue&type=template&id=4c754872&"
import script from "./ServiceAccounts.vue?vue&type=script&lang=js&"
export * from "./ServiceAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports